import axios from 'axios';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import type { RFIdListPayload, RFIdListResponse } from './Model';

type InitialState = {
  loading: boolean;
  response: RFIdListResponse;
  successMsg: string;
  error: string;
};

const initialState: InitialState = {
  loading: false,
  response: {} as RFIdListResponse,
  successMsg: '',
  error: '',
};

export const rfIdList = createAsyncThunk<RFIdListResponse, RFIdListPayload>(
  'rfIdList/rfIdList',
  async (payload: RFIdListPayload, { rejectWithValue }) => {
    try {
      // Basic Auth Credentials
      const baseUrl = 'https://erp-ssssh.technicise.eu';
      const accessToken = '3703265d357a211:5b86c8948ff269d';

      const response = await axios.get(
        `${baseUrl}/api/resource/${payload.doctype}?`, 
        {
          params: { fields: '["serial_no","item_code","name"]' },
          headers: {
            'Accept': 'application/json',
            'Authorization': `token ${accessToken}`
          }
        }
      );

      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.error?.message || 'Failed to fetch patient data'
      );
    }
  }
);

const rfIdListSlice = createSlice({
  name: 'rfIdList',
  initialState,
  reducers: {
    updateRFIdListClearMsg: (state) => {
      state.successMsg = '';
      state.error = '';
    },
    updateRFIdListClearRes: (state) => {
      state.successMsg = '';
      state.error = '';
      state.response = {} as RFIdListResponse;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(rfIdList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      rfIdList.fulfilled,
      (state, action: PayloadAction<RFIdListResponse>) => {
        state.loading = false;
        state.response = action.payload;
        state.successMsg = 'Patient details fetched successfully';
      },
    );
    builder.addCase(rfIdList.rejected, (state, action) => {
      state.loading = false;
      state.response = {} as RFIdListResponse;
      state.successMsg = '';
      state.error = String(action.payload) || 'Something went wrong';
    });
  },
});

export const { updateRFIdListClearMsg, updateRFIdListClearRes } =
  rfIdListSlice.actions;
export default rfIdListSlice.reducer;
